import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispensasjoner } from '@origo/planregister';
import { Loader, Notice } from '@origo/origo-ui';
import DispensationsPage from './DispensationsPage';
import { toDispensationGroups } from '../../mappers/toDispensations';
import type { DispensationGroup } from '../../types';

interface DispensationsContainerProps {
    napId: string;
}

const DispensationsContainer: React.FC<DispensationsContainerProps> = ({ napId }) => {
    const { t } = useTranslation();
    const { data, isLoading, isError } = useDispensasjoner(napId);

    const groups = useMemo(
        () => (data ? toDispensationGroups(data, t) : []),
        [data, t]
    );

    const [openGroups, setOpenGroups] = useState<Set<DispensationGroup['key']>>(new Set(['approved']));

    if (isLoading) return <Loader label={t('common.loading')} />;
    if (isError) return <Notice variant="danger">{t('common.errorLoading')}</Notice>;

    return (
        <DispensationsPage
            groups={groups}
            openGroups={openGroups}
            onToggleGroup={key =>
                setOpenGroups(prev => {
                    const next = new Set(prev);
                    if (next.has(key)) next.delete(key);
                    else next.add(key);
                    return next;
                })
            }
        />
    );
};

export default DispensationsContainer;
